import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import VisitorList from "../components/layout/VisitorList";
import { Button, Icon, Label, Loader, Menu, Popup } from "semantic-ui-react";
import { handleAttenders } from "../store/actions/athleteActions";
import AddVisitor from "../components/layout/AddVisitor";

const EventsInfo = (props) => {
  const [event, setEvent] = useState([]);
  const [advocate, showAdvocate] = useState(false);
  const [visitor, setVisitor] = useState(false);
  const [defaultView, setDefault] = useState(true);
  const [list, setList] = useState(false);
  const [newVisitors, setNewVisitors] = useState([]);
  const [showListAdd, setListAdd] = useState(true);

  const dispatch = useDispatch();
  useEffect(() => {
    if (Object.keys(props.event).length > 0) {
      setEvent(props.event);
    }
  }, [props.event]);
  const handleAttend = () => {
    const attenders = [...event.eventAttenders];
    if (!attenders.includes(props.loggedUser)) {
      attenders.push(props.loggedUser);
    } else if (attenders.includes(props.loggedUser)) {
      for (let i = 0; i < attenders.length; i++) {
        if (attenders[i] === props.loggedUser) {
          attenders.splice(i, 1);
          i--;
        }
      }
    }
    dispatch(handleAttenders(props.match?.params?.id, attenders));
  };
  useEffect(() => {
    if (event && event.eventAttenders) {
      if (event.eventAttenders.includes(props.loggedUser)) {
        setVisitor(true);
      } else setVisitor(false);
    }
  }, [event, props.loggedUser]);

  const handleRemoveVisitor = (visitor) => {
    const attenders = [...event.eventAttenders];
    if (attenders.includes(visitor)) {
      for (let i = 0; i < attenders.length; i++) {
        if (attenders[i] === visitor) {
          attenders.splice(i, 1);
          i--;
        }
      }
    }
    dispatch(handleAttenders(props.match?.params?.id, attenders));
  };
  return (
    <>
      <div className="AthleteDetailsBackground cu-profile">
        <div className="AthleteDetailsBannerBar"></div>
        {event && Object.keys(event).length > 0 ? (
          <div className="info-page">
            <div className="AthleteSearchBanner main-filter-event">
              <a
                href={event.eventUrl}
                target="_blank"
                rel="noopener noreferrer"
                key="facebook"
              >
                <h1>{event.eventName}</h1>
              </a>
              <div className="AthleteSearchFilterContainer"></div>
            </div>
            <>
              <div className="event-btn-data abs-btn only-one">
                {!props.auth.isEmpty && (
                  <>
                    <Popup
                      trigger={
                        <Button
                          circular
                          icon
                          basic={visitor ? true : false}
                          color="green"
                          onClick={() => handleAttend()}
                        >
                          <Icon name="user" />
                        </Button>
                      }
                      content={`Click Here To ${
                        !visitor ? "Attend" : "Not Attend"
                      }`}
                      size="small"
                    />
                  </>
                )}
              </div>
            </>
            <div className="data-bg">
              <div className="datas">
                <p>
                  {event.eventEndDate !== event.eventStartDate
                    ? "Start "
                    : "Event "}
                  Date:
                </p>
                <span>{event.eventStartDate}</span>
              </div>
              {event.eventEndDate !== event.eventStartDate && (
                <div className="datas">
                  <p>End Date:</p>
                  <span>
                    {event.eventEndDate ? event.eventEndDate : "One Day Event"}
                  </span>
                </div>
              )}
              {event.eventLocation && (
                <div className="datas">
                  <p>Location:</p>
                  <span>{event.eventLocation}</span>
                </div>
              )}
              {event.eventSport && (
                <div className="datas">
                  <p>Sport:</p>
                  <span>{event.eventSport}</span>
                </div>
              )}
              {event.eventAdvocate && (
                <div className="datas">
                  <p>Advocate Name:</p>
                  <span>{props.advocateName}</span>
                </div>
              )}
              <div className="datas align-center">
                <p>Attendants:</p>
                <span>
                  <Label color="teal" onClick={() => {}}>
                    {event.eventAttenders && event.eventAttenders.length}
                  </Label>
                </span>
              </div>
            </div>
            <div className="relative">
              {showListAdd && (
                <Menu className="cu-tab" pointing secondary>
                  <Menu.Item
                    name="Athletes"
                    active={!advocate}
                    onClick={() => showAdvocate(false)}
                  />
                  <Menu.Item
                    name="Advocate"
                    active={advocate}
                    onClick={() => showAdvocate(true)}
                  />
                </Menu>
              )}
              <div
                className={
                  !showListAdd ? "gridBoxDiv afterClass" : "gridBoxDiv "
                }
              >
                {props.superAdmin && showListAdd && (
                  <Button
                    icon="plus"
                    floated="right"
                    circular
                    color="green"
                    onClick={() => setListAdd(!showListAdd)}
                  />
                )}
                {!advocate && showListAdd && (
                  <>
                    <Popup
                      content="Standard View"
                      trigger={
                        <Button
                          className={
                            defaultView ? "primary small-btn" : "small-btn"
                          }
                          onClick={() => {
                            setList(false);
                            setDefault(true);
                          }}
                        >
                          <Icon name="list ul" />
                        </Button>
                      }
                    />
                    <Popup
                      content="Detailed View"
                      trigger={
                        <Button
                          className={list ? "primary small-btn" : "small-btn"}
                          onClick={() => {
                            setList(true);
                            setDefault(false);
                          }}
                        >
                          <Icon name="server" />
                        </Button>
                      }
                    />
                  </>
                )}
                {!showListAdd && (
                  <>
                    {props.superAdmin && (
                      <Button
                        basic
                        icon="check"
                        circular
                        color="green"
                        onClick={() => {
                          if (newVisitors.length > 0) {
                            dispatch(
                              handleAttenders(
                                props.match?.params?.id,
                                newVisitors
                              )
                            );
                            setListAdd(true);
                          } else setListAdd(true);
                        }}
                      />
                    )}
                    <Button
                      basic
                      icon="close"
                      floated="right"
                      circular
                      color="red"
                      onClick={() => setListAdd(true)}
                    />
                  </>
                )}
              </div>
            </div>
            {showListAdd ? (
              <div className="list">
                <VisitorList
                  defaultView={defaultView}
                  flag={advocate}
                  listOne={
                    props.athAttendant.length > 0
                      ? props.athAttendant.sort((a, b) =>
                          a.name.toLowerCase() > b.name.toLowerCase()
                            ? 1
                            : b.name.toLowerCase() > a.name.toLowerCase()
                            ? -1
                            : 0
                        )
                      : props.athAttendant
                  }
                  listTwo={
                    props.advAttendant.length > 0
                      ? props.advAttendant.sort((a, b) =>
                          a.name.toLowerCase() > b.name.toLowerCase()
                            ? 1
                            : b.name.toLowerCase() > a.name.toLowerCase()
                            ? -1
                            : 0
                        )
                      : props.advAttendant
                  }
                  remove={handleRemoveVisitor}
                  superAdmin={props.superAdmin}
                />
              </div>
            ) : (
              <div className="list with-visitor">
                <AddVisitor
                  visitorOptions={props.visitorOptions}
                  visitors={event.eventAttenders}
                  getVisitors={(newVisitors) => {
                    setNewVisitors(newVisitors);
                  }}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="SpinnerBackground">
            <div className="SpinnerContainer">
              <Loader size="large" active inline="centered" />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  let advocateName;
  let event = {};
  let copyArray = [];
  let attendantNames = [];
  let filteredOptions = [];
  let uid;
  let role;
  let newUserKey;

  const athAttendant = [];
  const advAttendant = [];
  const newVisitorOptions = [];

  if (ownProps.match?.params?.id && state.firestore.data.events) {
    event = { ...state.firestore.data.events[ownProps.match?.params?.id] };
    event.eventStartDate =
      typeof event.eventStartDate !== "string"
        ? event.eventStartDate.toDate().toDateString()
        : event.eventStartDate;
    event.eventEndDate =
      typeof event.eventEndDate !== "string"
        ? event.eventEndDate.toDate().toDateString()
        : event.eventEndDate;
  }

  if (
    state.firestore.data.advocates &&
    state.firestore.data.adminAthletes &&
    Object.keys(event).length > 0
  ) {
    if (event.eventAdvocate) {
      advocateName = state.firestore.data.advocates[event.eventAdvocate].name;
    }
    const athKeys = Object.keys(state.firestore.data.adminAthletes);
    const advKeys = Object.keys(state.firestore.data.advocates);

    let attenders = event.eventAttenders;
    attenders = attenders.map((visitor) => {
      const person = {};
      if (visitor in state.firestore.data.adminAthletes) {
        person.name =
          state.firestore.data.adminAthletes[visitor].firstName +
          " " +
          state.firestore.data.adminAthletes[visitor].lastName;
        person.image = state.firestore.data.adminAthletes[visitor].thumbnail;
        person.id = visitor;
        person.customUrl =
          state.firestore.data.adminAthletes[visitor].customUrl;
        person.extraData = state.firestore.data.adminAthletes[visitor];
      } else if (visitor in state.firestore.data.advocates) {
        person.name = state.firestore.data.advocates[visitor].name;
        person.image = state.firestore.data.advocates[visitor].thumbnailUrl;
        person.id = visitor;
        person.customUrl = state.firestore.data.advocates[visitor].customUrl;
      }
      return person;
    });
    event.attenders = attenders;
    // for options
    advKeys.forEach((key) => {
      newVisitorOptions.push({
        key,
        text: state.firestore.data.advocates[key].name,
        value: state.firestore.data.advocates[key].name,
      });
    });
    athKeys.forEach((key) => {
      newVisitorOptions.push({
        key,
        text: `${state.firestore.data.adminAthletes[key].firstName} ${state.firestore.data.adminAthletes[key].lastName}`,
        value: `${state.firestore.data.adminAthletes[key].firstName} ${state.firestore.data.adminAthletes[key].lastName}`,
      });
    });

    // filteringOptions
    copyArray = JSON.parse(JSON.stringify(event.attenders));
    copyArray.forEach((e) =>
      e.customUrl ? athAttendant.push(e) : advAttendant.push(e)
    );
    attendantNames = copyArray.map((value) => value.name);
    filteredOptions = newVisitorOptions.filter(
      (value) => !attendantNames.includes(value.text)
    );
  }
  if (state.firebase.auth && state.firestore.data.userRole) {
    uid = state.firebase.auth.uid;
    const keys = Object.keys(state.firestore.data.userRole);
    keys.forEach((key) => {
      if (state.firestore.data.userRole[key].userUID === uid) {
        role = state.firestore.data.userRole[key].role;
        if (role === "newUser") {
          newUserKey = uid;
        }
      }
    });
  }
  return {
    newUserKey,
    role,

    loggedUser: state.firebase.auth.uid,
    superAdmin: state.auth.superAdmin,
    auth: state.firebase.auth,
    advocateName,
    athAttendant: athAttendant.filter((e) => Object.keys(e).length > 0),
    advAttendant: advAttendant.filter((e) => Object.keys(e).length > 0),
    visitorOptions: filteredOptions,
    event,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "adminAthletes",
    },
    {
      collection: "advocates",
    },
    {
      collection: "events",
    },
    {
      collection: "userRole",
    },
  ])
)(EventsInfo);
